/* Offer quantities use the native product form; Shopify owns all pricing and discount eligibility. */
(function () {
  'use strict';

  function quantityAllowed(quantity, min, max, step) {
    return Number.isInteger(quantity) && quantity >= min && quantity <= max && (quantity - min) % step === 0;
  }

  function eligibleTier(tiers, quantity, min, max, step) {
    if (!quantityAllowed(quantity, min, max, step)) return null;
    return tiers.filter(function (tier) {
      return tier.code && tier.quantity >= 2 && tier.quantity <= quantity;
    }).sort(function (a, b) { return b.quantity - a.quantity; })[0] || null;
  }

  function tierQuantity(threshold, min, max, step) {
    var quantity = min + Math.ceil((Math.max(threshold, min) - min) / step) * step;
    return quantityAllowed(quantity, min, max, step) ? quantity : null;
  }

  function discountUrl(root, cart, code, location) {
    var destination = new URL(cart, location.origin);
    var preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) destination.searchParams.set('preview_theme_id', preview);
    return root.replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destination.pathname + destination.search);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { quantityAllowed: quantityAllowed, eligibleTier: eligibleTier, tierQuantity: tierQuantity, discountUrl: discountUrl };
  }
  if (typeof window === 'undefined' || customElements.get('ss-product-offers')) return;

  customElements.define('ss-product-offers', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.addButton = this.querySelector('[data-offer-add]');
      this.error = this.querySelector('[data-offer-error]');
      this.tiers = Array.from(this.querySelectorAll('[data-offer-quantity]')).map(function (button) {
        return { button: button, quantity: Number(button.dataset.offerQuantity), code: button.dataset.offerCode.trim() };
      });
      if (!this.root || !this.addButton) return;
      this.onClick = this.handleClick.bind(this);
      this.onChange = this.sync.bind(this);
      this.addEventListener('click', this.onClick);
      this.root.addEventListener('change', this.onChange);
      this.root.addEventListener('input', this.onChange);
      this.observer = new MutationObserver((changes) => {
        if (changes.some((change) => !this.contains(change.target))) this.sync();
      });
      this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'min', 'max', 'step', 'value', 'data-min'] });
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.root?.removeEventListener('change', this.onChange);
      this.root?.removeEventListener('input', this.onChange);
      this.observer?.disconnect();
    }

    sync() {
      this.form = document.getElementById(this.dataset.formId);
      this.quantityInput = this.form?.elements.namedItem('quantity');
      this.nativeButton = this.form?.querySelector('[name="add"]');
      this.hidden = !this.form || !this.quantityInput || !this.nativeButton;
      if (this.hidden) return;
      this.min = Math.max(1, Number(this.quantityInput.min) || 1);
      this.max = this.quantityInput.hasAttribute('max') ? Number(this.quantityInput.max) : Infinity;
      this.step = Math.max(1, Number(this.quantityInput.step) || 1);
      this.quantity = Number(this.quantityInput.value);
      this.activeTier = eligibleTier(this.tiers, this.quantity, this.min, this.max, this.step);
      this.unavailable = !this.form.elements.namedItem('id')?.value || this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
      this.tiers.forEach((tier) => {
        tier.button.disabled = this.busy || this.unavailable || tierQuantity(tier.quantity, this.min, this.max, this.step) === null;
        tier.button.setAttribute('aria-pressed', String(tier === this.activeTier));
      });
      this.addButton.disabled = this.busy || this.unavailable || !this.activeTier;
      this.querySelector('[data-offer-choose]').hidden = !!this.activeTier;
    }

    handleClick(event) {
      var tierButton = event.target.closest('[data-offer-quantity]');
      if (tierButton && !tierButton.disabled) {
        this.sync();
        var quantity = tierQuantity(Number(tierButton.dataset.offerQuantity), this.min, this.max, this.step);
        if (quantity !== null) {
          this.quantityInput.value = quantity;
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      if (event.target.closest('[data-offer-add]')) this.addOffer();
    }

    async addOffer() {
      this.sync();
      if (this.busy || this.unavailable || !this.activeTier || !this.form.reportValidity()) return;
      // Construct before disabling controls: retain all line properties, files and selling plans.
      var formData = new FormData(this.form);
      var code = this.activeTier.code;
      formData.set('quantity', String(this.quantity));
      formData.delete('sections');
      formData.delete('sections_url');
      this.busy = true;
      this.error.hidden = true;
      this.addButton.textContent = this.dataset.pendingLabel;
      this.setAttribute('aria-busy', 'true');
      this.nativeButton.setAttribute('aria-disabled', 'true');
      this.sync();
      try {
        var response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
        var result = await response.json();
        if (!response.ok || result.status) {
          var cartError = new Error(this.dataset.errorLabel);
          cartError.shopperMessage = typeof result.description === 'string' ? result.description : this.dataset.errorLabel;
          throw cartError;
        }
        // Never create a cart permalink: that could discard an existing cart or personalization.
        window.location.assign(discountUrl(this.dataset.rootUrl, this.dataset.cartUrl, code, window.location));
      } catch (error) {
        this.error.textContent = error.shopperMessage || this.dataset.errorLabel;
        this.error.hidden = false;
        this.busy = false;
        this.nativeButton.removeAttribute('aria-disabled');
        this.removeAttribute('aria-busy');
        this.addButton.textContent = this.dataset.buttonLabel;
        this.sync();
      }
    }
  });
}());
